import React, { useState } from "react";
import { connect } from "react-redux";
import {
  Button,
  Dialog,
  DialogContent,
  //DialogTitle,
  useMediaQuery,
  Typography,
  useTheme,
  Grid,
} from "@mui/material";

const CouponQRCode = (props) => {
  const {
    couponPrice,
    popupContentOnly = false,
    onCancel = null,
    hideOkBtn = false,
  } = props;
  const [showQrCodePopup, setShowQrCodePopup] = useState(false);
  const theme = useTheme();
  const matchesMinWidth = useMediaQuery("(max-width:600px)");
  const matches = useMediaQuery(theme.breakpoints.down("lg"));

  const qrCode = () => {
    return (
      <Grid
        id="qrCode"
        sx={{
          width: matches ? "10%" : undefined,
          cursor: "pointer",
          display: "flex",
          alignItems: "end",
          marginLeft: matches ? "-10%" : "-8.3%",
        }}
        item
        sm={1}
        // className="float"
        onClick={() => setShowQrCodePopup(!showQrCodePopup)}
      >
        <Typography
          variant="h1LatoBlack"
          component={"div"}
          sx={{
            fontSize: matches ? "12px" : "18px",
            color: "#093d4c",
            letterSpacing: "0.70px",
            lineHeight: matches ? "0.9rem" : "1.4rem",
            textAlign: "center",
            pointerEvents: "auto",
            //border: "solid 1px #fff",
            marginRight: "5px",
            marginLeft: "-20px",
          }}
        >
          <img
            src={couponPrice?.qrCodeUrl}
            style={{
              width: "90%",
              height: "90%",
              paddingTop: "10px",
              //borderRadius: "50%",
            }}
            alt="qr-code"
            className="qr-code"
          />
        </Typography>
      </Grid>
    );
  };

  const popupContent = () => {
    return (
      <Grid sx={{ display: matches ? "grid" : "contents" }}>
        <Typography
          variant="h1LatoBlack"
          component={"div"}
          sx={{
            fontSize: matches ? "16px" : "18px",
            color: "#093d4c",
            letterSpacing: "0.70px",
            lineHeight: matches ? "0.9rem" : "1.4rem",
            textAlign: "center",
            pointerEvents: "auto",
          }}
        >
          Scan QR Code to get savings! <br />
          <img
            src={couponPrice?.qrCodeUrl}
            style={{
              width: "90%",
              height: "90%",
              //paddingBottom: "15px",
              paddingTop: "25px",
            }}
            alt="qr-code"
            className="qr-code"
          />
        </Typography>
        {!hideOkBtn && (
          <Grid sx={{ display: "flex", justifyContent: "center" }} pb={1}>
            <Button
              sx={{
                height: "40px",
                minWidth: matchesMinWidth ? 100 : 300,
              }}
              variant="large"
              onClick={() => {
                setShowQrCodePopup(false);
                onCancel && onCancel();
              }}
            >
              OK
            </Button>
          </Grid>
        )}
      </Grid>
    );
  };

  return (
    <>
      {popupContentOnly && popupContent()}
      {!popupContentOnly && (
        <>
          {qrCode()}
          {showQrCodePopup && (
            <Dialog
              fullWidth={true}
              maxWidth={"sm"}
              onClose={() => setShowQrCodePopup(false)}
              open={showQrCodePopup}
              className="app-dialog"
            >
              <DialogContent>{popupContent()}</DialogContent>
            </Dialog>
          )}
        </>
      )}
    </>
  );
};

const mapStateToProps = (state) => {
  return {
    couponPrice: state.couponPrice.data,
  };
};

export default connect(mapStateToProps)(CouponQRCode);
